export interface DeviceCapabilities {
  hasHover: boolean;
  hasTouch: boolean;
}

export const hasHoverCapability = (): boolean => {
  if (typeof window === "undefined" || !window.matchMedia) {
    return false;
  }

  return window.matchMedia("(hover: hover)").matches;
};

export const hasTouchCapability = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  // Null or function means touch is supported
  if (
    "ontouchstart" in window &&
    (window.ontouchstart === null || typeof window.ontouchstart === "function")
  ) {
    return true;
  }

  // maxTouchPoints for modern browsers
  if (navigator && navigator.maxTouchPoints && navigator.maxTouchPoints > 0) {
    return true;
  }

  // DocumentTouch for legacy browsers
  if (
    "DocumentTouch" in window &&
    document instanceof
      (window as unknown as { DocumentTouch: new () => Document }).DocumentTouch
  ) {
    return true;
  }

  return false;
};

export const getDeviceCapabilities = (): DeviceCapabilities => {
  return {
    hasHover: hasHoverCapability(),
    hasTouch: hasTouchCapability(),
  };
};
